module.exports = __webpack_public_path__ + "5841d3a7067c11043b5ca3c96ac2650c.fbx";